module.exports = __webpack_public_path__ + "img/ic_share_ig.86ffaef8.svg";